import { Helmet } from "react-helmet";
import { useLocation } from "wouter";

const BASE_URL = "https://id.io.net";

const CanonicalLink = () => {
  const [location] = useLocation();

  const canonicalUrl = location.includes("explorer")
    ? `${window.location.origin}${location}`
    : BASE_URL;

  return (
    <Helmet>
      {/* This link tag will be dynamically injected into the document's <head> */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalLink;
